import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = {
  key: 1,
  class: "profile-content"
}
const _hoisted_3 = { class: "profile-header" }
const _hoisted_4 = { class: "user-basic-info" }
const _hoisted_5 = { class: "username" }
const _hoisted_6 = { class: "user-signature" }
const _hoisted_7 = { class: "profile-actions-header" }
const _hoisted_8 = { class: "profile-details" }
const _hoisted_9 = { class: "detail-section" }
const _hoisted_10 = { class: "detail-item" }
const _hoisted_11 = { class: "detail-item" }
const _hoisted_12 = { class: "detail-item" }
const _hoisted_13 = { class: "detail-item" }
const _hoisted_14 = { class: "detail-section" }
const _hoisted_15 = { class: "stats-grid" }
const _hoisted_16 = { class: "stat-number" }
const _hoisted_17 = { class: "stat-number" }
const _hoisted_18 = { class: "stat-item" }
const _hoisted_19 = { class: "stat-number" }
const _hoisted_20 = { class: "stat-item" }
const _hoisted_21 = { class: "stat-number" }
const _hoisted_22 = {
  key: 0,
  class: "detail-section"
}
const _hoisted_23 = { class: "detail-item" }
const _hoisted_24 = { class: "detail-section" }
const _hoisted_25 = { class: "detail-item" }
const _hoisted_26 = { class: "detail-item" }
const _hoisted_27 = {
  key: 2,
  class: "error"
}

import { ref, computed, watch } from 'vue';
import { ElDialog, ElAvatar, ElButton, ElMessage } from 'element-plus';
import { getUserById, followUser } from '@/user/api/userApi';  // 导入关注API
import { useStore } from 'vuex';
import { formatDate } from '@/utils/date';
import ReportModal from '../report/ReportModal.vue';

// --- API响应接口定义 ---
interface OtherUserProfile {
  id: number;
  username: string;
  name: string;
  avatar: string;
  email?: string;
  phone?: string;
  signature?: string;
  status: number;
  roleName: string;
  createTime: string;
  isFolloweed: number;  // 是否关注了该用户 0否1是
  isFollowerd: number;  // 该用户是否关注了我 0否1是
  likeCount: number;
  postCount: number;
  followerCount: number;
  followeeCount: number;
}

interface ApiResponse {
  code: number;
  msg: string | null;
  data: OtherUserProfile;
}

interface Props {
  modelValue: boolean;
  userId: number;
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void;
  (e: 'close'): void;
  (e: 'report-user', payload: { targetType: number, targetId: number }): void;
  (e: 'follow-status-change'): void; // 关注状态改变时触发
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OtherUserProfileModal',
  props: {
    modelValue: { type: Boolean },
    userId: {}
  },
  emits: ["update:modelValue", "close", "report-user", "follow-status-change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const store = useStore();

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const userProfile = ref<OtherUserProfile | null>(null);
const loading = ref(false);
const statusText = ref('');
const statusClass = ref('');
const reportModalRef = ref(); // 添加举报模态框引用

// 获取当前登录用户信息
const currentUser = computed(() => {
  return store.state.userInfo || { id: null };
});

// 关注状态相关的计算属性
const followStatusText = computed(() => {
  if (!userProfile.value) return '';
  if (userProfile.value.isFolloweed === 1 && userProfile.value.isFollowerd === 1) {
    return '互相关注';
  } else if (userProfile.value.isFolloweed === 0 && userProfile.value.isFollowerd === 1) {
    return '对方已关注你';
  } else if (userProfile.value.isFolloweed === 1 && userProfile.value.isFollowerd === 0) {
    return '已关注';
  } else {
    return '未关注';
  }
});

const followStatusClass = computed(() => {
  if (!userProfile.value) return '';
  if (userProfile.value.isFolloweed === 1 && userProfile.value.isFollowerd === 1) {
    return 'status-mutual';
  } else if (userProfile.value.isFolloweed === 0 && userProfile.value.isFollowerd === 1) {
    return 'status-follower';
  } else if (userProfile.value.isFolloweed === 1) {
    return 'status-followed';
  } else {
    return 'status-not-followed';
  }
});

// 更新状态相关信息
const updateStatusInfo = (status: number) => {
  switch (status) {
    case 0:
      statusText.value = '封禁';
      statusClass.value = 'status-banned';
      break;
    case 1:
      statusText.value = '正常';
      statusClass.value = 'status-normal';
      break;
    case 2:
      statusText.value = '禁言';
      statusClass.value = 'status-muted';
      break;
    default:
      statusText.value = '未知';
      statusClass.value = 'status-unknown';
  }
};

const loadUserProfile = async () => {
  if (!props.userId) return;

  try {
    loading.value = true;
    
    // 调用API获取用户资料
    const response = await getUserById(props.userId);
    
    console.log('API Response:', response); // 添加调试日志
    
    // 检查响应结构并提取数据
    let userData = null;
    
    // 情况1: 直接返回用户数据
    if (response.id) {
      userData = response;
    } 
    // 情况2: 包含标准响应格式 { code: 1, msg: null, data: {...} }
    else if (response.data && response.data.code === 1 && response.data.data) {
      userData = response.data.data;
    }
    // 情况3: 兼容其他可能的格式
    else if (response.data && typeof response.data === 'object' && response.data.id) {
      userData = response.data;
    }
    
    if (userData) {
      userProfile.value = userData;
      // 更新状态信息
      updateStatusInfo(userData.status);
    } else {
      console.error('API返回的数据格式不正确:', response);
      throw new Error('获取用户资料失败：数据格式不正确');
    }
  } catch (error: any) {
    console.error('获取用户资料失败:', error);
    userProfile.value = null;
    ElMessage.error('获取用户资料失败');
  } finally {
    loading.value = false;
  }
};

// 关注/取消关注用户
const handleFollow = async () => {
  if (!userProfile.value) return;
  
  if (currentUser.value.id === userProfile.value.id) {
    ElMessage.warning('不能关注自己');
    return;
  }

  try {
    // 直接调用关注API，无需确认
    const response = await followUser(userProfile.value.id);
    
    if (response.code === 1) {
      // 保存原来的关注状态
      const wasFollowed = userProfile.value.isFolloweed === 1;
      
      // 更新关注状态
      userProfile.value.isFolloweed = userProfile.value.isFolloweed === 1 ? 0 : 1;
      
      // 更新统计数
      if (userProfile.value.isFolloweed === 1) {
        
        // 如果对方原本关注了当前用户，粉丝数也要+1
        if (userProfile.value.isFollowerd === 1) {
          userProfile.value.followerCount = (userProfile.value.followerCount || 0) + 1;
        }
        
        ElMessage.success(`已成功关注 ${userProfile.value.name || userProfile.value.username}`);
      } else {
        
        // 如果对方之前关注了当前用户，粉丝数也要-1
        if (userProfile.value.isFollowerd === 1 && wasFollowed) {
          userProfile.value.followerCount = Math.max(0, (userProfile.value.followerCount || 0) - 1);
        }
        
        ElMessage.success(`已取消关注 ${userProfile.value.name || userProfile.value.username}`);
      }
      
      // 触发关注状态改变事件，通知父组件更新
      emit('follow-status-change', {
        userId: userProfile.value.id,
        isFollowed: userProfile.value.isFolloweed === 1,
        followeeCount: userProfile.value.followeeCount,
        followerCount: userProfile.value.followerCount
      });
    } else {
      ElMessage.error(response.msg || '操作失败');
    }
  } catch (error: any) {
    console.error('关注操作失败:', error);
    ElMessage.error('操作失败，请稍后再试');
  }
};

// 显示关注列表
const showFollowings = () => {
  if (!userProfile.value) return;
  // 触发事件让父组件显示关注列表
  emit('show-followings', userProfile.value.id);
};

// 显示粉丝列表
const showFollowers = () => {
  if (!userProfile.value) return;
  // 触发事件让父组件显示粉丝列表
  emit('show-followers', userProfile.value.id);
};

// 关闭对话框
const handleClose = () => {
  emit('close');
};

// 举报用户
const openReportDialog = () => {
  if (!userProfile.value) return;
  
  // 检查是否为自己，如果是则不允许举报
  if (currentUser.value.id === userProfile.value.id) {
    ElMessage.warning('不能举报自己');
    return;
  }
  
  // 通过emit向父组件传递举报事件
  emit('report-user', {
    targetType: 3, // 3 表示用户
    targetId: userProfile.value.id
  });
};

// 监听弹窗显示状态变化
watch([dialogVisible, () => props.userId], ([newDialogVisible, newUserId], [oldDialogVisible, oldUserId]) => {
  // 当弹窗变为可见或userId发生变化时加载用户资料
  if (newDialogVisible && (newUserId !== oldUserId || !userProfile.value || userProfile.value.id !== newUserId)) {
    loadUserProfile();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
    title: "用户信息",
    width: "600px",
    "close-on-click-modal": false,
    "before-close": handleClose,
    class: "warm-theme-dialog"
  }, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "加载中..."))
        : (userProfile.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(ElAvatar), {
                  size: 100,
                  src: userProfile.value.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
                  class: "profile-avatar"
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", _hoisted_5, _toDisplayString(userProfile.value.name || userProfile.value.username || '未知用户'), 1),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(userProfile.value.signature || '暂无签名'), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (currentUser.value.id !== userProfile.value.id && userProfile.value.isFolloweed === 0 && userProfile.value.isFollowerd === 0)
                    ? (_openBlock(), _createBlock(_unref(ElButton), {
                        key: 0,
                        type: "primary",
                        size: "small",
                        onClick: handleFollow
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode(" 关注 ", -1)
                        ]))]),
                        _: 1
                      }))
                    : (currentUser.value.id !== userProfile.value.id && userProfile.value.isFolloweed === 0 && userProfile.value.isFollowerd === 1)
                      ? (_openBlock(), _createBlock(_unref(ElButton), {
                          key: 1,
                          type: "danger",
                          size: "small",
                          onClick: handleFollow
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode(" 回关 ", -1)
                          ]))]),
                          _: 1
                        }))
                      : (currentUser.value.id !== userProfile.value.id && userProfile.value.isFolloweed === 1 && userProfile.value.isFollowerd === 0)
                        ? (_openBlock(), _createBlock(_unref(ElButton), {
                            key: 2,
                            type: "warning",
                            size: "small",
                            onClick: handleFollow
                          }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                              _createTextVNode(" 已关注 ", -1)
                            ]))]),
                            _: 1
                          }))
                        : (currentUser.value.id !== userProfile.value.id && userProfile.value.isFolloweed === 1 && userProfile.value.isFollowerd === 1)
                          ? (_openBlock(), _createBlock(_unref(ElButton), {
                              key: 3,
                              type: "success",
                              size: "small",
                              onClick: handleFollow
                            }, {
                              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode(" 互相关注 ", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                  _createVNode(_unref(ElButton), {
                    type: "danger",
                    size: "small",
                    onClick: openReportDialog,
                    disabled: currentUser.value.id === userProfile.value.id
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode(" 举报用户 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "section-title" }, "账户信息", -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", null, "用户账号:", -1)),
                    _createElementVNode("span", null, _toDisplayString(userProfile.value.username || '未设置'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[7] || (_cache[7] = _createElementVNode("label", null, "用户邮箱:", -1)),
                    _createElementVNode("span", null, _toDisplayString(userProfile.value.email || '未填写'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", null, "联系电话:", -1)),
                    _createElementVNode("span", null, _toDisplayString(userProfile.value.phone || '未填写'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", null, "注册时间:", -1)),
                    _createElementVNode("span", null, _toDisplayString(_unref(formatDate)(userProfile.value.createTime)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "section-title" }, "统计信息", -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", {
                      class: "stat-item",
                      onClick: showFollowings
                    }, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(userProfile.value.followeeCount || 0), 1),
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "stat-label" }, "关注数", -1))
                    ]),
                    _createElementVNode("div", {
                      class: "stat-item",
                      onClick: showFollowers
                    }, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(userProfile.value.followerCount || 0), 1),
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "stat-label" }, "粉丝数", -1))
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(userProfile.value.postCount || 0), 1),
                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "stat-label" }, "作品数", -1))
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(userProfile.value.likeCount || 0), 1),
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "stat-label" }, "获赞数", -1))
                    ])
                  ])
                ]),
                (currentUser.value.id !== userProfile.value.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "section-title" }, "关系状态", -1)),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[16] || (_cache[16] = _createElementVNode("label", null, "关注状态:", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(followStatusClass.value)
                        }, _toDisplayString(followStatusText.value), 3)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_24, [
                  _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "section-title" }, "账户状态", -1)),
                  _createElementVNode("div", _hoisted_25, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", null, "用户角色:", -1)),
                    _createElementVNode("span", null, _toDisplayString(userProfile.value.roleName || '普通用户'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", null, "账户状态:", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(statusClass.value)
                    }, _toDisplayString(statusText.value), 3)
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_27, "无法加载用户信息"))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})